import { useAtomValue } from 'jotai';
import React from 'react';

import { usePractitionerRole } from '~/hooks/use-practitioner-role';
import { telemedicineAppointmentsState } from '~/state/layouts/SharedAppShell/atoms';

import { TelemedicineNotification } from './TelemedicineNotification';
import { useSubscriptionTelemedicineAppointment } from './use-subscription-telemedicine_appointment';

export const TelemedicineNotifications = () => {
  const { appointments } = useAtomValue(telemedicineAppointmentsState);
  const { handleDelete } = useSubscriptionTelemedicineAppointment();
  const { verifyRole } = usePractitionerRole();

  const isPharmacist = verifyRole(['pharmacist']);

  return (
    <>
      {appointments.map((appointment) => (
        <TelemedicineNotification
          key={appointment.id}
          pharmacist={isPharmacist}
          appointment={appointment}
          onClose={handleDelete}
        />
      ))}
    </>
  );
};
